import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdvanceSearchComponent } from '../person-search/advance-search/advance-search/advance-search.component';
import { jdParserResponse, JdSearchComponent } from '../person-search/jd-search/jd-search.component';
import { SimilarCandidatesComponent } from '../person-search/similar-candidates/similar-candidates.component';
import { PersonSearchService } from '../_services/person-search.service';
import { GenAiJdSearchComponent } from '../gen-ai-jd-search/gen-ai-jd-search.component';
import { from, of, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { JdData } from '../common-interfaces-classes/JdData';
import { JdDataService } from '../jd-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HashService } from '../_services/hash.service';
import { GeneralConstants } from '../constants/GeneralConstants';
import { LocalStorageService } from '../_services/local-storage.service';
import { CreateTalentpoolComponent } from '../talentpool/create-talentpool/create-talentpool.component';
import { AbstractControl } from '@angular/forms';
import { Location } from '@angular/common';
import { SimilarCandidateFilterComponent } from '../similar-candidate-filter/similar-candidate-filter.component';
import { DefaultLocationModalComponent } from '../default-location-modal/default-location-modal.component';
import * as _ from 'underscore';


import { GlobalService } from '../_services/global.service';
import cjson from 'compressed-json';
import { FilterDataHandlerService } from '../_services/filter-data-handler.service';

type profileType = {
  value: string;
  job_title: string;
  job_company_name: string;
  full_name: string;
  linkedin_url: string;
  id: string;
  location_name: string;
  full_name_with_middle_name?: string;
  location_continent?: string
}

export interface nlSearchResoponse {
  status: string;
  data: {
    preferredskills?: string[];
    mandatoryskills?: string[];
    educationaldegrees?: string[];
    industries: string[];
    jobtitles: string[];
    locations: string[];        // Assuming string array, could be expanded if structure known
    yearsofexperience: {
      min: number | null;
      max: number | null;
    };
    companies: string[];
    fieldofstudy: string[];
    schools: string[];
    suggestedjobtitle: string[];
    tools: string[];
    continents: string[];
    exactlocationmatch: string | null;
    normalizedlocations: { exactlocationmatch: string, continent: string }[];
  };
  message: string;
}

@Component({
    selector: 'app-nl-search',
    templateUrl: './nl-search.component.html',
    styleUrls: ['./nl-search.component.scss'],
    standalone: false
})
export class NlSearchComponent implements OnInit {
  showList = false;
  profiles: profileType[] = [];
  private typeaheadSubject = new Subject<string>();
  activeIndex: number | null = null;
  constructor(private modalService: NgbModal, private filterDataHandlerService: FilterDataHandlerService, private personSearchService: PersonSearchService, private jdDataService: JdDataService, private router: Router,
    private hashService: HashService, private localStorageService: LocalStorageService, private route: ActivatedRoute, private location: Location
  ) { }
  searchText = '';
  searchKeyword: string = '';
  successMessage: string = '';
  errorMessage: string = '';
  historySubject: Subject<any> = new Subject<any>();
  savedHistorySubject: Subject<any> = new Subject<any>();
  username: string;
  suggestedList = [];
  @ViewChild('searchWrapper') searchWrapper!: ElementRef;
  inputError: boolean = false;
    showHistoryViewAll: any;
  showSavedHistoryViewAll: any;
showListonhover:boolean=false;
@HostListener('document:click', ['$event'])
onClickOutside(event: MouseEvent) {
  if (!this.searchWrapper.nativeElement.contains(event.target)) {
    this.showList = false;
  }
}
defaultContinent: string = null;

  hideList() {
    setTimeout(() => this.showList = false, 150);
  }

  ngOnInit() {
    this.localStorageService.setItem('region', null);
    // this.defaultContinent = this.localStorageService.getItem('defaultContinent');
    // if(!this.defaultContinent)
    //    this.openDefaultContinentModal();
    this.username = this.localStorageService.getItem('ufname');
    this.suggestedList = [
      {
        key: 1,
        value: 'Search for backend engineers in India  with 5–8 years of experience in Java and Spring Boot, currently working in fintech companies, and experienced in building scalable microservices.'
      },
      {
        key: 2,
        value: 'Find enterprise sales leaders with insurance or BFSI experience, skilled in account expansion, deal closures, and revenue growth from new york.'
      },
      {
        key: 3,
        value: 'Data analysts in India with 3+ years experience in SQL, Python, and Power BI from retail, FMCG companies'
      }
    ];

    this.typeaheadSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(keyword =>
        keyword?.trim().length >= 3
          ? this.personSearchService.getPersonSearchListing(keyword,'personsuggestion')
          : of([])
      )
    ).subscribe((res: any) => {
      this.profiles = res?.data ?? res ?? [];
    });
  }

  onSearchInput() {
    this.typeaheadSubject.next(this.searchKeyword);
  }

  openAdvancedSearch(type?: string) {
    this.localStorageService.setItem('nlSearchKeyword', null);

    const modalRef = this.modalService.open(AdvanceSearchComponent, { size: 'lg' as 'lg', windowClass: 'modal-size', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.keywordtype = type;
    modalRef.componentInstance.nlsearchKeyword = this.searchKeyword;

  }

  openJobDescription() {
    this.localStorageService.setItem('nlSearchKeyword', null);
    const modalRef = this.modalService.open(JdSearchComponent, { size: 'md', windowClass: 'modal-size', centered: true, backdrop: 'static', keyboard: false });
  }

  openIdealCandidate() {
    this.localStorageService.setItem('nlSearchKeyword', null);

    const modalRef = this.modalService.open(SimilarCandidatesComponent, { windowClass: 'NLSearchMdmodal', centered: true, backdrop: 'static', keyboard: false });
  }

  autoResize(event: Event) {
    this.inputError = false;
    const textarea = event.target as HTMLTextAreaElement;

    textarea.style.height = 'auto';

    const lineHeight = 24;        // approx line height in px
    const maxLines = 4;
    const maxHeight = lineHeight * maxLines;

    const newHeight = Math.min(textarea.scrollHeight, maxHeight);
    textarea.style.height = newHeight + 'px';

    const res = textarea.value.replace(/ /g, '')
    let scriptRegex = /<(.*)>/g;
    if(res && (scriptRegex.test(res.trim()) == true)){
      this.inputError = true;
    } else{
      this.inputError = false;
    }
  }

  openProfile(profile: profileType) {
    this.setFilterDataInLocalStorage(profile);
  }

  /**
   * set Filter data
   * @param replace
   */
  setFilterDataInLocalStorage(replace: profileType) {
    const filterData = this.filterDataHandlerService.fetchFilterData;
    filterData.jobTitleSelectedList = replace.job_title ? [this.prepareFilterChipData(replace.job_title)] : [];
    filterData.companySelectedList = replace.job_company_name ? [this.prepareFilterChipData(replace.job_company_name)] : [];
    filterData.fullNameSelectedList = replace.value ? [this.prepareFilterChipData(replace.value)] : [];
    filterData.locationSelectedList = replace.location_name ? [this.prepareFilterChipData(replace.location_name)] : [];
    filterData.continentstobeincluded = replace?.location_continent ? [replace?.location_continent]: [];
    filterData.includePersons = replace.id ? [replace.id] : [];
    filterData.savehistory = true;

    const localKey = GlobalService.hash(JSON.stringify(cjson.compress(filterData)));
    localStorage.setItem(localKey, JSON.stringify(cjson.compress(filterData)));
    this.router.navigate(['/person/search/listing'], { queryParams: { filter: localKey, keyword: '*', type: 'advanced-search' } });
  }

  /**
   * prepare Filter chip data for person suggestions
   */
  prepareFilterChipData(value: string){
    return {
      key: value,
      isExcluded: false,
      isMandatory: false,
      chipkey: value
    }
  }

  onMouseOver() {
  this.showListonhover= true;
    if( this.showListonhover= true){
      this.showList = false
    }else{
      this.showList = true

    }
  }

  onMouseLeave() {
   this.showListonhover= false;
    if( this.showListonhover= false){
      this.showList = true
    }else{
      this.showList = true
    }

  }
  openSearchResult(type?: string) {
    if(this.searchKeyword?.length > 2000) {
      return;
    }
    const payload = {
      user_query: this.searchKeyword
    }
    this.localStorageService.setItem('nlSearchKeyword', this.searchKeyword);
    const modalRef = this.modalService.open(
      GenAiJdSearchComponent,
      { windowClass: 'genAimodal', centered: true, backdrop: 'static', keyboard: false }
    );
    const modalInstance: GenAiJdSearchComponent = modalRef.componentInstance;
    modalInstance.description = this.searchKeyword;
    modalRef.componentInstance.calledFrom = 'nl-search';

    const modalResult$ = from(modalRef.result);
    modalResult$.subscribe((response: nlSearchResoponse) => {
      if (response) {
        const convertedResponse = this.convertToJdResponse(response);
        this.openSimilarCandidateFilters(convertedResponse, true, type);

      }
    }
    )
  }

  convertToJdResponse(jdResp: nlSearchResoponse): JdData {
    if (!jdResp || jdResp.status !== 'success' || !jdResp.data) {
      throw new Error("Invalid Jd parse response format.");
    }

    const data = jdResp.data;
    let mergeJobTitles = data?.jobtitles?.slice(1) || [];
    mergeJobTitles = mergeJobTitles.concat(mergeJobTitles, data?.suggestedjobtitle || [])
    const jdData = {
      "Job Title": data.jobtitles[0] || null,
      "Suggested job Title": mergeJobTitles,
      "Preferred Skills": data.preferredskills || [],
      "Tools": data.tools.length ? data.tools : null,
      "Years of experience": {
        "minimum experience": data.yearsofexperience?.min ?? null,
        "maximum experience": data.yearsofexperience?.max ?? null
      },
      "Relevant Year of experience": {
        "minimum experience": data.yearsofexperience?.min ?? null,
        "maximum experience": data.yearsofexperience?.max ?? null
      },
      "Industry": data.industries || [],
      "Location": {
        "city": null,
        "state": null,
        "country": null,
        "continent": data.continents && data.continents.length > 0 ? data.continents[0] : null
      },
      "Target Company": data.companies.length ? data.companies : [],
      "Degree": data.educationaldegrees || [],
      "Field of study": data.fieldofstudy || [],
      "School": data.schools.length ? data.schools : null,
      "Mandatory Skills": data.mandatoryskills || [],
      "exactLocationMatch": data.exactlocationmatch || null,
      "normalizedlocations": data.normalizedlocations || [],
      "normalizedcontinents": data.normalizedlocations.map(loc => loc.continent) || []
    };
    return {
      status: 'success',
      jdData: jdData
    }


  }

  createTalentpool() {
    const modalRef = this.modalService.open(CreateTalentpoolComponent, { size: 'lg' as 'lg', backdrop: 'static', keyboard: false, centered: true, });
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'talentpool-added') {
        this.toastmessage('Talentpool Created Succesfully', 'success')

      } else if (x == 'talentpool-edited') {
        this.toastmessage('Talentpool Edited Succesfully', 'success')

      }

      else if (x == 'error') {
        this.toastmessage('Something went wrong, Please try again in a minute', 'error')
      }
    })

  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }

  openTalentInsights() {
    this.router.navigate(['/talent-insights'], { queryParams: { redirectSource: GeneralConstants.REDIRECT_SOURCES.NL_SEARCH } });
  }

  viewAllHistory(saveMode: boolean = false) {
    this[saveMode ? 'savedHistorySubject' : 'historySubject'].next(undefined as any);
  }

  checkHistory(event, saveMode: boolean = false) {
    if (event === 'REFRESH') {
      this.savedHistorySubject.next(event);
    } else {
      this[saveMode ? 'showSavedHistoryViewAll' : 'showHistoryViewAll'] = event;
    }
  }

  openSearchResultWithPrompt(value: string) {
    this.searchKeyword = value;
  }

  private openSimilarCandidateFilters(jdResponse: JdData, firstLoad = false, type?: string) {
     const similarobj = firstLoad ? this.jdDataService.getSimilarObj(jdResponse) : this.jdDataService.jdDataFromSession;
      this.personSearchService.passsimilarcandidatesdata({ data: similarobj, calledfrom: "nl-search" });
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          type: 'nl-search',
        },
        queryParamsHandling: 'merge'
      });
      if (similarobj?.jobtitle?.length > 0) {
        this.modalService.dismissAll();
        this.personSearchService.passsimilarcandidatesdata(similarobj);
        this.jdDataService.emitjdDataForRedirect(similarobj);


        const uniqueHash = this.hashService.generateUniqueHash();
            if(type == 'talent-insights') {

         this.router.navigate(
        ['/talentpool-insights'],
        {

          queryParams: {
            type: GeneralConstants.REDIRECT_SOURCES.NL_SEARCH,
            uniqueHash
          },
          queryParamsHandling: 'merge', // remove to replace all query params by provided
        }
      );
      } else {
  this.router.navigate(
                  ['/person/search/listing'],
                  {
                    queryParams: {
                      type: GeneralConstants.REDIRECT_SOURCES.NL_SEARCH,
                      uniqueHash
                    },
                  }
                );
      }

      } else {
        this.modalService.dismissAll();
        const modalRef = this.modalService.open(SimilarCandidateFilterComponent, { size: 'xl', windowClass: 'modal-size', centered: true, backdrop: 'static', keyboard: false });
        modalRef.componentInstance.disableDisableButton = firstLoad;
        modalRef.result.then((res) => {
          if (res.action == 'submit') {
            this.personSearchService.passsimilarcandidatesdata(res);
            this.jdDataService.emitjdDataForRedirect(res.data);
            const uniqueHash = this.hashService.generateUniqueHash();
            if(type == 'talent-insights') {
              this.router.navigate(
                ['/talentpool-insights'],
                {
                  queryParams: {
                    type: GeneralConstants.REDIRECT_SOURCES.NL_SEARCH,
                    uniqueHash
                  },
                  queryParamsHandling: 'merge', // remove to replace all query params by provided
                }
              );
            } else {
                  this.router.navigate(
                  ['/person/search/listing'],
                  {
                    queryParams: {
                      type: GeneralConstants.REDIRECT_SOURCES.NL_SEARCH,
                      uniqueHash
                    },
                  }
                );
            }

          } else if (res.action === 'close' && firstLoad) {
            this.location.back();
          }
        });



      }
    }

    openDefaultContinentModal() {
        const modalRef = this.modalService.open(DefaultLocationModalComponent, {  windowClass: 'NLSearchMdmodal', centered: true, backdrop: 'static', keyboard: false });
        modalRef.componentInstance.modalDismissEvent.subscribe((res) => {
          if(res === 'success'){
            this.toastmessage('Default continent set successfully', 'success');
          }
      }  )

    }

  /**
   * Navigates to the project creation page.  
   */
  createProject() {
    this.localStorageService.clearItem('parshedJD');
    setTimeout(() => {
      this.router.navigate(['/projects/create'], { queryParams: { source: 'create' } });
    }, 100);
  } 

}
